import SEOMeta from '@/components/feature/SEOMeta';
import SchemaOrg from '@/components/feature/SchemaOrg';
import Hero from './components/Hero';
import WebsiteGrid from './components/WebsiteGrid';
import FeaturedSection from './components/FeaturedSection';
import FAQSection from './components/FAQSection';
import { siteInfo } from '@/mocks/siteInfo';

export default function Home() {
  const webPageSchema = {
    name: '韩漫导航 - 韩漫网站入口汇总',
    description: '汇集韩漫网站、韩漫网、韩漫之家与韩漫屋等热门平台入口，提供免费韩漫漫画网址导航与在线观看汇总。',
    url: siteInfo.url,
    inLanguage: 'zh-CN',
  };

  return (
    <main>
      <SEOMeta
        title="韩漫 韩漫网站 - 韩漫网_韩漫之家_韩漫屋 | 韩漫平台入口"
        description="汇集韩漫网站、韩漫网、韩漫之家与韩漫屋等热门平台入口，提供免费韩漫漫画网址导航与在线观看汇总，方便漫迷集中浏览与收藏韩漫资源。"
        keywords="韩漫网站,韩漫网,韩漫之家,韩漫屋,韩漫平台入口,韩漫漫画网站,免费韩漫网址,韩漫在线观看,韩漫导航,韩漫网址大全,漫画韩漫网址,韩漫吧"
        canonicalUrl="https://hanman.site/"
      />
      <SchemaOrg type="WebPage" data={webPageSchema} />

      <Hero />
      <WebsiteGrid />
      <FeaturedSection />
      <FAQSection />

      <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-primary-500">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-4">
            发现更多韩漫平台
          </h2>
          <p className="text-white/80 text-sm md:text-base mb-8 max-w-xl mx-auto">
            我们持续收录最新、最全的韩漫网址，助你探索更多精彩韩漫世界
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4">
            <div className="flex flex-col items-center">
              <strong className="font-heading text-3xl font-bold text-white">{siteInfo.stats.platforms}</strong>
              <span className="text-white/70 text-sm mt-1">收录平台</span>
            </div>
            <div className="w-px h-12 bg-white/20 hidden sm:block"></div>
            <div className="flex flex-col items-center">
              <strong className="font-heading text-3xl font-bold text-white">{siteInfo.stats.users}</strong>
              <span className="text-white/70 text-sm mt-1">漫迷用户</span>
            </div>
            <div className="w-px h-12 bg-white/20 hidden sm:block"></div>
            <div className="flex flex-col items-center">
              <strong className="font-heading text-3xl font-bold text-white">{siteInfo.stats.articles}</strong>
              <span className="text-white/70 text-sm mt-1">攻略文章</span>
            </div>
            <div className="w-px h-12 bg-white/20 hidden sm:block"></div>
            <div className="flex flex-col items-center">
              <strong className="font-heading text-3xl font-bold text-white">{siteInfo.stats.categories}</strong>
              <span className="text-white/70 text-sm mt-1">内容分类</span>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}